import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Quote, ArrowRight } from 'lucide-react';
import { TESTIMONIALS } from '../constants/testIds';

const QUOTES = [
  {
    quote: 'Ordered our first 40ft container and the tread grading was spot on — zero rejects at receiving.',
    name: 'Marcus D.',
    role: 'Tire Shop Owner, GA',
  },
  {
    quote: 'Straightforward process and the tripling packing saved us real money on freight.',
    name: 'Priya K.',
    role: 'Export Distributor',
  },
  {
    quote: 'Finally a wholesaler that answers the phone and ships exactly what they promise.',
    name: 'Daniel O.',
    role: 'Fleet Operations Manager',
  },
];

export const Testimonials = () => (
  <section data-testid={TESTIMONIALS.section} className="bg-brand-bg py-24 sm:py-28">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <p className="font-mono text-xs uppercase tracking-widest text-brand-amber mb-3">Customer Reviews</p>
      <h2 className="font-display font-extrabold uppercase tracking-tight text-brand-text text-3xl sm:text-4xl max-w-2xl">
        Trusted by Shops, Fleets &amp; Exporters
      </h2>
      <Link to="/testimonials" className="mt-4 inline-flex items-center gap-1.5 font-mono text-xs uppercase tracking-wider text-brand-orange hover:text-brand-orangeHover transition-colors">
        See all reviews <ArrowRight className="w-3.5 h-3.5" />
      </Link>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
        {QUOTES.map((q, i) => (
          <motion.div
            key={q.name}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            className="rounded-2xl border border-brand-border bg-brand-surface p-7"
          >
            <Quote className="w-6 h-6 text-brand-orange mb-4" />
            <p className="text-brand-text text-sm sm:text-base leading-relaxed">&ldquo;{q.quote}&rdquo;</p>
            <p className="mt-5 font-display font-bold text-brand-text uppercase text-sm">{q.name}</p>
            <p className="font-mono text-xs text-brand-muted uppercase tracking-wider">{q.role}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
